import localScaleManager from "../../../helpers/LocalScaleManager";
import { Parser } from "../../../helpers/parser";

export class BestHand {
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.bg = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "best-hand-text-place")
      .setOrigin(0);
    this.table.poolArray.push(this.bg);

    this.text = "";
    this.text = this.text.padStart(15, "a");
    this.textObj = this.scene.add
      .bitmapText(0, 0, "HelveticaNeue", this.text)
      .setAlpha(0.5);
    this.table.poolArray.push(this.textObj);

    this.textObj.setData("width", this.textObj.width);
    this.textObj.setData("height", this.textObj.height);
    this.visibilityControls(false);
  }
  /**
   * @param text {string}
   */
  show(text) {
    if (!this.bg.visible) this.visibilityControls(true);
    this.text = text;
    const textDemo = Parser.convertToXLetters(text, 15);
    this.textObj.setText(textDemo);
    this.textObj.setX(
      this.bg.x + (this.bg.displayWidth - this.textObj.width) / 2
    );
  }
  hide() {
    if (!this.bg.visible) return;
    this.visibilityControls(false);
  }
  visibilityControls(visibility) {
    if (this.bg.visible !== visibility) this.bg.setVisible(visibility);
    if (this.textObj.visible !== visibility)
      this.textObj.setVisible(visibility);
  }
  /**
   * @param width of table
   * @param height of table
   * @param initX of table
   * @param initY of table
   */
  positionControls(initX, initY, width, height) {
    // localScaleManager.scaleSprite(
    //   this.bg,
    //   width * .19,
    //   width * .19,
    //   0,
    //   1,
    //   false
    // );
    localScaleManager.scaleSprite(
      this.bg,
      width * 0.245,
      width * 0.245,
      0,
      1,
      false
    );
    // this.bg.setPosition(initX + (width - this.bg.displayWidth) / 2, initY + height - this.bg.displayHeight * 2.5);
    this.bg.setPosition(
      initX + (width - this.bg.displayWidth) / 2,
      initY + height - this.bg.displayHeight * 2.1
    );
    localScaleManager.scaleBitMapText(
      this.textObj,
      this.bg.displayWidth * 0.75,
      this.bg.displayHeight * 0.5,
      0,
      1,
      false
    );
    this.textObj.setPosition(
      this.bg.x + (this.bg.displayWidth - this.textObj.width) / 2,
      this.bg.y + this.bg.displayHeight * 0.78
    );
  }
  /**
   * @param width of table
   * @param height of table
   * @param initX of table
   * @param initY of table
   */
  reposition(initX, initY, width, height) {
    this.bg.setPosition(
      initX + (width - this.bg.displayWidth) / 2,
      initY + height - this.bg.displayHeight * 2.1
    );
    this.textObj.setPosition(
      this.bg.x + (this.bg.displayWidth - this.textObj.width) / 2,
      this.bg.y + this.bg.displayHeight * 0.78
    );
  }
}
